import { Link } from 'react-router';

import { ROUTES } from '@/app/router/routes';

export const NotFoundPage = () => (
  <div className="py-16 text-center">
    <p className="text-sm font-medium text-slate-500">Erreur 404</p>
    <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-900">Page introuvable</h1>
    <p className="mt-2 text-slate-600">
      Cette adresse ne correspond à aucune page de l’application.
    </p>
    <Link
      to={ROUTES.home}
      className="mt-6 inline-flex h-10 items-center rounded-md bg-slate-900 px-4 text-sm font-medium text-white hover:bg-slate-800"
    >
      Retour à l’accueil
    </Link>
  </div>
);
